import React from 'react';
import PropTypes from 'prop-types';

import styles from './SearchResultsContainer.m.sass';

import {connect} from 'react-redux';
import {fetchSearchByQuery} from '../../ducks/search';

import {Link} from 'react-router';

import Loader from '../loader/Loader';
import ChannelImage from '../../containers/channelUtils/ChannelImage';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';


@connect(({search}, {query}) => ({searchResults: search[query]}))
export default class SearchResultsContainer extends React.PureComponent {
  componentDidMount() {
    const {dispatch, query, searchResults} = this.props;

    if (query && searchResults === undefined) {
      dispatch(fetchSearchByQuery(query));
    }
  }

  componentDidUpdate(prevProps) {
    const {dispatch, query, searchResults} = this.props;

    if (query && searchResults === undefined) {
      dispatch(fetchSearchByQuery(query));
    }
  }

  render() {
    const {searchResults} = this.props;

    if (!searchResults) {
      return (
        <div className={styles.searchResults}>
          <Loader block/>
        </div>
      );
    }

    if (!searchResults.length) {
      return (
        <div className={styles.searchResults}>
          <div className={styles.searchResults_notice}>
            Sorry, no matching items were found
          </div>
        </div>
      );
    }

    return (
      <div className={styles.searchResults}>
        {searchResults.map(item => (
          <Link
            key={item.code}
            className={styles.searchResultItem}
            to={`/service/${item.slug}`}
          >
            <div className={styles.searchResultItem_image}>
              <ChannelImage
                src={item.images[0]}
              />
            </div>
            <div className={styles.searchResultItem_description}>
              <div className={styles.searchResultItem_title}>
                {item.name}
              </div>

              <div className={styles.searchResultItem_subtitle}>
                <ChannelPrice
                  className={styles.searchResultItem_price}
                  price={item.price}
                />

                {item.mainTaxon.name}
              </div>
            </div>
          </Link>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/searchResultsContainer/SearchResultsContainer.js